import { api } from './client';

export interface Plan {
  id: string;
  name: string;
  key: string;
  description: string | null;
  price: number;
  features: PlanFeature[];
  createdAt: string;
  updatedAt: string;
}

export interface System {
  id: string;
  name: string;
  key: string;
  description: string | null;
  icon: string | null;
  url: string | null;
  status: 'active' | 'inactive';
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  plans?: Plan[];
}

export interface CreateSystemInput {
  name: string;
  key: string;
  description?: string;
  icon?: string;
  url?: string;
  planKeys?: string[];
}

export interface UpdateSystemInput {
  id: string;
  name: string;
  key: string;
  description?: string;
  icon?: string;
  url?: string;
  planKeys?: string[];
}

export interface PlanFeature {
  key: string;
  name: string;
  limit: string;
}

export interface CreatePlanInput {
  name: string;
  key: string;
  price: number;
  description?: string;
  features: PlanFeature[];
}

export interface UpdatePlanInput {
  id: string;
  name: string;
  key: string;
  price: number;
  description?: string;
  features: PlanFeature[];
}

export const marketApi = {
  getSystems: async () => {
    const response = await api.get<System[]>('/api/market/systems');
    return response.data;
  },
  getAllPlans: async () => {
    const response = await api.get<Plan[]>('/api/market/plans/all');
    return response.data;
  },
  getPlans: async (systemKey: string) => {
    const response = await api.get<Plan[]>(`/api/market/plans?systemKey=${systemKey}`);
    return response.data;
  },
  createSystem: async (data: CreateSystemInput) => {
    const response = await api.post<System>('/api/market/systems', data);
    return response.data;
  },
  updateSystem: async (data: UpdateSystemInput) => {
    const response = await api.put<System>(`/api/market/systems/${data.id}`, data);
    return response.data;
  },
  deleteSystem: async (id: string) => {
    await api.delete(`/api/market/systems/${id}`);
  },
  toggleSystemListing: async (id: string) => {
    const response = await api.patch<System>(`/api/market/systems/${id}/toggle-listing`);
    return response.data;
  },
  reorderSystems: async (orders: Array<{ id: string; sortOrder: number }>) => {
    await api.put('/api/market/systems/reorder', orders);
  },
  createPlan: async (data: CreatePlanInput) => {
    const response = await api.post<Plan>('/api/market/plans', data);
    return response.data;
  },
  updatePlan: async (data: UpdatePlanInput) => {
    const response = await api.put<Plan>(`/api/market/plans/${data.id}`, data);
    return response.data;
  },
  deletePlan: async (id: string) => {
    await api.delete(`/api/market/plans/${id}`);
  },
};
